import { atom } from "recoil";
import LoginUserType from "../types/LoginUserType";
 
export const LoginUserAtom = atom<LoginUserType>({
  key: "loginUser",
  default: {
    userId: "",
    email: "",
    userName: "",
    accessToken: "",
    algorithm: ""
  },
});
